import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Row, Col, List, Avatar } from "antd";
import { formatBytes, getFileImage, getFullDateHours } from "utils/helpers";
import { ReactComponent as DownloadFile } from 'assets/icons/download_blue.svg';
import { downloadUploadedFile, openUploadedFile } from 'store/forms/actions';
import { isBeneficiary } from 'utils';
import { useLocation } from 'react-router-dom';

const Documents = () => {
  const dispatch = useDispatch();
  const ApplicationFilesList = useSelector(state=> state.appTrack?.apptrackDetails?.contentItems);
  const ApplicationFilesListMainforms = useSelector(state => state.forms?.documents?.contentItems);
  const groups = useSelector(state => state.user?.groups);
  const location = useLocation();
  const appTrack = location.pathname.includes('apptrack');

  const fileOrder = [
    "supEquipmentDoc",
    "supCertEquipmentDoc",
    "supDespDeclar",
    "supCertGemi",
    "supRegistryTaxisnet",
    "supIbanDetails",
    "supOtherDocs",
    "supAdditionalDocs",
    "auditorEvaluation",
    "supObjDocs",
    "objectionEvaluation",
  ];

  const selectedList = !isBeneficiary(groups)
    ? (appTrack ? ApplicationFilesList : ApplicationFilesListMainforms)
    : ApplicationFilesList;

  const sortedList = [...(selectedList || [])].sort((a, b) => {
    const aField = a.items[0]?.field;
    const bField = b.items[0]?.field;
    const aIndex = fileOrder.indexOf(aField);
    const bIndex = fileOrder.indexOf(bField);

    return (aIndex === -1 ? Infinity : aIndex) - (bIndex === -1 ? Infinity : bIndex);
  });

  return (
    <Row gutter={16}>
      <Col span={24} className='mb-1'>
       <List
  className="applicationFilesList no-border"
  itemLayout="vertical"
  dataSource={sortedList}
  renderItem={(item) => (
    <div key={item.title}>
      <div className="application-file-header">{item?.title}</div>
      {item.items.map((info, index) => (
        <List.Item
          key={info.id || index}
          extra={
            <div className="file-uris">
              <div className="open-file-wrapper file-actions">
                <a
                  className="application-open-file-text"
                  onClick={(e) => {
                    e.preventDefault();
                    dispatch(openUploadedFile(info));
                  }}
                  target="_blank"
                >
                  Άνοιγμα
                </a>
              </div>
              <div className="file-actions">
                <a
                  className="application-download-file-text"
                  onClick={(e) => {
                    e.preventDefault();
                    dispatch(downloadUploadedFile(info));
                  }}
                  download={info.name}
                >
                  <DownloadFile /> Download
                </a>
              </div>
            </div>
          }
        >
          <List.Item.Meta
            className={index === 0 ? "first" : ""}
            avatar={<Avatar src={getFileImage(info.simpleType)} />}
            title={
              <div style={{ display: "flex" }}>
                <span className="application-file-name">{info.name}</span>
              </div>
            }
            description={
              <div style={{ display: "flex" }}>
                <span className="application-file-size">
                  {formatBytes(info.size)}
                </span>
                <span className="application-file-size">
                  , Updated: {getFullDateHours(info.created)}
                </span>
              </div>
            }
          />
        </List.Item>
      ))}
    </div>
  )}
/>

      </Col>
    </Row>
  );
};

export default Documents;
